import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard } from 'lucide-react';
export function FinancingTeaser() {
  return <section className="bg-brand-blue py-16" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 bg-brand-blue-dark rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-111">
          <div className="flex items-start gap-6" data-id="element-112">
            <div className="hidden sm:flex w-16 h-16 rounded-full bg-white/10 items-center justify-center shrink-0" data-id="element-113">
              <CreditCard size={32} className="text-white" data-id="element-114" />
            </div>
            <div data-id="element-115">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-white mb-3" data-id="element-116">
                Flexible Financing Options Available
              </h2>
              <p className="font-body text-blue-100 text-lg max-w-xl" data-id="element-117">
                Don't let budget constraints delay important exterior repairs.
                Reach out today to learn more about what's available for your
                project.
              </p>
            </div>
          </div>
          <div className="shrink-0 w-full md:w-auto" data-id="element-118">
            <Link to="/financing" className="block w-full text-center bg-white text-brand-blue font-body font-bold text-lg py-4 px-8 rounded-lg hover:bg-gray-50 transition-colors shadow-lg" data-id="element-119">
              Contact Us About Financing
            </Link>
          </div>
        </div>
      </div>
    </section>;
}